import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'angular5-toaster';
import { TramApiService } from '../tram-api.service';
import { State } from '../core/state';
import { Review, EnhancedReview, ModerationStatus, UsingMode, AbstractEnhancedReview } from '../core/review';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { StorageService } from '../storage.service';
import { ReviewService } from '../providers/review.service';
import { User } from '../core/user';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'feed',
    templateUrl: './feed.component.html',
    styleUrls: ['./feed.component.scss']
})
export class FeedComponent implements OnInit {
    ModerationStatus = ModerationStatus;
    UsingMode = UsingMode;
    user: User;

    mode: UsingMode = UsingMode.User;

    reviews: AbstractEnhancedReview[] = [];

    isLoading: boolean = false;
    isReviewFormOpened: boolean = true;

    constructor(
        private storage: StorageService,
        private formBuilder: FormBuilder,
        public reviewService: ReviewService,
        private api: TramApiService,
        private toaster: ToasterService) {
    }

    ngOnInit() {
        this.mode = UsingMode.Anonymous;

        let currentUserPromise: Promise<User> = null;
        if (this.storage.isSensitiveDataExist.value) {
            currentUserPromise = this.api.getCurrentUser();
        }

        let portionPromise = this.reviewService.getReviewsPortion();

        Promise.all([currentUserPromise, portionPromise])
            .then(data => {
                this.user = data[0];
                if (this.user) {
                    this.mode = this.user && this.user.isModerator
                        ? UsingMode.God
                        : UsingMode.User;
                }

                let portion = data[1];
                this.reviews = this.filterReviewPortion(portion);
            })
            .catch(error => this.handleError(error));
    }

    onReviewRemoving(review: EnhancedReview) {
        this.reviewService
            .deleteReview(review)
            .then(() => {
                const index = this.reviews.findIndex(r => r.id === review.id);
                if (index >= 0) {
                    this.reviews.splice(index, 1);

                    this.toaster.pop('success', null, 'Отзыв удален');
                }
            })
            .catch(error => this.handleError(error));
    }

    onReviewFormClosed(review: AbstractEnhancedReview) {
        if (review)
            this.reviews.unshift(review);
    }

    getMore() {
        if (this.isLoading)
            return;

        this.isLoading = true;
        if (this.reviewService.isEndReached)
            return;

        this.reviewService.getReviewsPortion(true)
            .then(portion => {
                let filteredPortion = this.filterReviewPortion(portion);
                this.reviews = this.reviews.concat(filteredPortion);
                this.isLoading = false;
            });
    }

    goUp() {
        //TODO animate smoothly scrolling up (not only here)

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    private filterReviewPortion(portion: AbstractEnhancedReview[]): AbstractEnhancedReview[] {
        const internalReviews = this.mode === UsingMode.God
            ? portion
            : this.mode === UsingMode.User
                ? portion.filter(r => (r.base.comment.status === ModerationStatus.Approved && r.isPublished) || r.userId === this.user.id)
                : portion.filter(r => r.base.comment.status === ModerationStatus.Approved);

        return internalReviews;
    }

    private handleError(error: HttpErrorResponse | string) {
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/feed.component.ts